import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

import commImg1 from "@/assets/images/promotion/credentials-carousel/comm-placeholders.png";
import commImg2 from "@/assets/images/promotion/credentials-carousel/comm-open-tracking.png";

export default function CredentialsCarouselCommCenter() {
  const { t } = useTranslation();

  return (
    <div className="flex h-full w-full select-none flex-col items-center gap-10 [&>p>strong]:text-background [&>p]:text-background/80 [&_h2]:text-xl [&_s]:opacity-40">
      <div className="flex flex-row-reverse gap-2">
        <a
          className="animate-[wiggle_1s_ease-in-out_infinite] text-[40px]"
          href="https://invono.se/kommunikation"
          target="_blank"
          rel="noopener noreferrer"
        >
          💌
        </a>

        <div className="flex flex-col gap-2">
          <Badge
            className="self-start p-0 px-2 font-bold text-primary"
            variant="outline-primary"
          >
            {t("generic.new")}
          </Badge>
          <h2 className="flex-1 [&>strong]:text-brand">
            <Trans i18nKey={"credentials_carousel.comm_center.heading"} />
          </h2>
        </div>
      </div>
      <div className="flex justify-between">
        <img
          width="47%"
          className="rounded-xl border-[5px] border-solid border-brand-400 shadow-lg"
          src={commImg1}
        />
        <img
          width="47%"
          className="rounded-xl border-[5px] border-solid border-brand-400 shadow-lg"
          src={commImg2}
        />
      </div>
      <Trans i18nKey="credentials_carousel.comm_center.body" />
    </div>
  );
}
